/**
 * Directive to handle clicking outside of an element.
 */
const clickOutside = {
  bind: (el, binding) => {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value();
      }
    };

    document.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: el => {
    document.removeEventListener('click', el.clickOutsideEvent);
  }
};

export default clickOutside;
